import * as React from "react";
import PropTypes from "prop-types";
import NoStyleButton from "nx-components/NoStyleButton";
import ErrorHandler from "nexia_mobile/components/ErrorHandler";

function TileBody({
  children,
  hasControls,
  header,
  onMouseDown,
  onTouchStart,
  backgroundStyle,
  innerRef,
}) {
  const styles = {
    body: {
      cursor: "pointer",
      width: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      bottom: hasControls ? "3em" : 0,
      ...backgroundStyle,
    },
    verticalCenter: {
      width: "100%",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
    },
  };

  return (
    <ErrorHandler>
      <NoStyleButton
        style={styles.body}
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
        innerRef={innerRef}
      >
        {header}
        <div style={styles.verticalCenter}>{children}</div>
      </NoStyleButton>
    </ErrorHandler>
  );
}
TileBody.propTypes = {
  children: PropTypes.node,
  hasControls: PropTypes.bool,
  header: PropTypes.element,
  onMouseDown: PropTypes.func,
  onTouchStart: PropTypes.func,
  backgroundStyle: PropTypes.object,
  innerRef: PropTypes.func,
};

export default TileBody;



// WEBPACK FOOTER //
// ./src/components/Tiles/TileBody.jsx